export default {
  setLoading(state, v) { state.loading = v; },
  setDepartments(state, v) { state.departments = v; },
  setConfirmationNumber(state, v) { state.confirmationNumber = v; },
  setErrors(state, errs) {
    state.errors = { ...state.errors, ...(errs || {}) };
  }
};